import { axiosV2 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';

export const getSocietyDeletionPreview = async (societyId: string) => {
  const { data } = await axiosV2.get(
    `/societies/${societyId}/deletion-preview`
  );

  return decryptResponse(data);
};
